import React, { useState, useEffect } from "react";
import { useParams } from "react-router";

import ContactFooter from "../../ContactFooter";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";

import { dbRefPitches } from "../../../firebase-config";
import { onValue } from "firebase/database";

import "../ProjectGallery/projectGallery.css";
import "../ProjectCard/projectCard.css";
import PitchGallery from "./PitchGallery";
import ModalPopup from "../../ModalPopup";
import Button from "../../Shared/Button";
import useScrollTo from "../../../hooks/useScrollTo";
import { useSelector } from "react-redux";
import ProjectsNavigation from "../ProjectsNavigation";
import { getPitches } from "../../../Datahandler";

const Pitches = () => {
  let { pitch } = useParams();
  const [showModal, setShowModal] = useState(false);
  const currentUser = useSelector((state) => state.user.loggedInUser);

  useScrollTo();

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const [pitches, setPitches] = useState([]);

  useEffect(() => {
    getPitches(currentUser ? currentUser.level : 0).then((res) => {
      setPitches(res);
    });
  }, [currentUser]);

  return (
    <>
      <div className="pitchesSection">
        <Container fluid>
          <br />
          <br />
          <Row>
            <Col xs={12} md={7} style={{ float: "left" }}>
              <h3>Our future adventures</h3>
            </Col>
          </Row>

          <Row>
            <section>
              <p>
                At The RIOT Labs, we're not content with resting on our laurels.
                We're always looking to the future and exploring new ways to
                push the envelope when it comes to new technology and business
                models. Join us on this exciting journey, and let's shape the
                future we want.
              </p>
              <p>
                Please check out our ongoing projects, perhaps you want to know
                more or sign up for one of them.
              </p>

              {currentUser && (
                <Button
                  buttonStyle="pink"
                  text="Pitch your own idea!"
                  onClick={() => handleOpenModal()}
                />
              )}
              <ProjectsNavigation />
            </section>
          </Row>

          <Row className="pitches-container">
            {pitches.length && <PitchGallery pitch={pitch} pitches={pitches} />}
          </Row>
          <Row className="pitches-container">
            <Col xs={12} md={4} style={{ textAlign: "right" }}>
              <img
                alt="riot ppl"
                class="project-image"
                src="https://firebasestorage.googleapis.com/v0/b/riotlabs-web.appspot.com/o/images%2Fpitches-industry.png?alt=media&token=be55e0e2-2ce5-41d1-9a3b-669c08fe3a68&_gl=1*17ay2r1*_ga*NzMzMjg4ODE4LjE2NzQ4MjM4MzM.*_ga_CW55HF8NVT*MTY4NTgzMzI1Mi4xMi4xLjE2ODU4MzMyOTYuMC4wLjA."
              />
            </Col>
          </Row>
        </Container>
      </div>
      {showModal && (
        <ModalPopup
          show={handleOpenModal}
          handleClose={handleCloseModal}
          description={
            "Fill up the form and we'll get back to you as soon as possible!"
          }
          title={"Pitch your idea!"}
          image={null}
          type={"createPitch"}
        />
      )}
      {window.location.toString().includes("pitches") && <ContactFooter />}
    </>
  );
};

export default Pitches;
